import { chartKeys } from 'utils/constant';

const probability_gain_after_loss = {
  chartTitle: 'Probability loss after loss',
  chartKey: chartKeys.PROBABILITY_LOSS_AFTER_LOSS,
}

export default probability_gain_after_loss;